import React from "react";

const IMAGES = [
    {
        url: "https://images.unsplash.com/photo-1563741603582-adf5a8332a73?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
        span: "md:col-span-7 md:row-span-2",
        label: "// chase_01",
    },
    {
        url: "https://images.unsplash.com/photo-1623346483743-b968a27ed34c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
        span: "md:col-span-5",
        label: "// drift_01",
    },
    {
        url: "https://images.unsplash.com/photo-1606512084153-189ffdc0f086?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
        span: "md:col-span-5",
        label: "// night_01",
    },
    {
        url: "https://images.pexels.com/photos/1707640/pexels-photo-1707640.jpeg?auto=compress&cs=tinysrgb&w=1200",
        span: "md:col-span-4",
        label: "// graffiti",
    },
    {
        url: "https://images.unsplash.com/photo-1517776832751-0a7e6993de03?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
        span: "md:col-span-4",
        label: "// urban_wall",
    },
    {
        url: "https://images.pexels.com/photos/14984574/pexels-photo-14984574.jpeg?auto=compress&cs=tinysrgb&w=1200",
        span: "md:col-span-4",
        label: "// pursuit",
    },
];

export default function Gallery() {
    return (
        <section
            id="galeria"
            data-testid="gallery-section"
            className="relative py-24 md:py-40"
        >
            <div className="max-w-[1440px] mx-auto px-6 md:px-12">
                <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-16">
                    <div>
                        <div className="flex items-center gap-3 mb-4">
                            <span className="h-px w-12 bg-neon-yellow" />
                            <span className="font-mono text-xs uppercase tracking-[0.3em] text-neon-yellow">
                                ▸ Cenas da pista
                            </span>
                        </div>
                        <h2 className="font-heading text-5xl md:text-7xl uppercase tracking-tighter leading-none">
                            Galeria
                            <br />
                            <span className="text-neon-yellow">in-game</span>
                        </h2>
                    </div>
                    <p className="text-white/60 max-w-md text-base md:text-lg">
                        Momentos roubados das ruas da Forza. Cada print conta uma
                        fuga, um drift, uma noite.
                    </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-12 gap-4 auto-rows-[220px] md:auto-rows-[260px]">
                    {IMAGES.map((img, i) => (
                        <div
                            key={i}
                            data-testid={`gallery-item-${i}`}
                            className={`${img.span} relative overflow-hidden border border-white/10 group`}
                        >
                            <img
                                src={img.url}
                                alt={img.label}
                                className="w-full h-full object-cover gallery-img"
                            />
                            <div className="absolute bottom-3 left-3 font-mono text-[10px] uppercase tracking-[0.2em] text-neon-yellow bg-black/70 px-2 py-1">
                                {img.label}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
